import { render, staticRenderFns } from "./uyeTanimla.vue?vue&type=template&id=2599841d&scoped=true&"
import script from "./uyeTanimla.vue?vue&type=script&lang=js&"
export * from "./uyeTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2599841d",
  null
  
)

export default component.exports